import { createContext, useContext, useMemo } from 'react';
import { useFeatureFlag } from '../../feature-flag';

export function useCmsFeatureFlagConfig() {
  const { isReady: isFlagLoaded, value } = useFeatureFlag(
    cmsFeatureFlags as Mutable<typeof cmsFeatureFlags>
  );
  return useMemo(() => {
    return {
      data: value,
      isReady: isFlagLoaded,
    } as ICmsFeatureFlagContext;
  }, [value, isFlagLoaded]);
}

/** context for cms feature Flag */
export const cmsFeatureFlagContext = createContext<ICmsFeatureFlagContext>({
  data: {},
  isReady: false,
});

/** `Hook` to access CmsFeatureFlagContext data */
export function useCmsFeatureFlagContext(contextData?: ICmsFeatureFlagContext) {
  const context = useContext(cmsFeatureFlagContext);
  return context ?? { data: {}, isReady: false };
}

export type ICmsFeatureFlagContext = {
  data: ObjectMap;
  isReady: boolean;
};

export const cmsFeatureFlags = [
  'X4C_EnableResourceBookmark',
  'X4C_EnableResourceRating',
  'X4C_ResourceRelatedContent',
  'X4C_EnableContentCount',
  'X4C_Enable_CloudToTS',
  'EnableSolutionX4CIntegration',
  'X4C_EnableCventLanding',
  'X4c_Enable_ThreeUseCases',
  'X4c_Enable_OpportunityQuotes',
  'X4C_IsGrowthIncentiveRedeemRewards_enabled',
  'X4c_Enable_GrowthOpportunity',
  'X4C_Enable_TSToCloud',
  'BI_TopVendors',
  'X4C_Enable_ResellerBusiness',
  'X4C_Ultra_Assessment_EmailNotification',
  'X4C_EnableMarketO',
  'X4C_EnableMarketingPreferenceNotification',
] as const;

type ObjectMap = {
  [key: string]: string;
};

type Mutable<T> = {
  -readonly [P in keyof T]: T[P];
};
